import store from "../store";
import axios from "axios";

class Form {
	async get() {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/form", {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	async getForm(uid) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/form/" + uid, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}
}

export default new Form();
